import { render, staticRenderFns } from "./FichaDoImovelDialog.vue?vue&type=template&id=8d7b2566&"
import script from "./FichaDoImovelDialog.vue?vue&type=script&lang=js&"
export * from "./FichaDoImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports